<div class="main-tab-title-box">
    <mat-card-title class="main-title">Metadiscourse</mat-card-title>
    <div>
        <analysis-options></analysis-options>
    </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
    <div  id="div_loader_pag">
      <div  class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysis will begin after you finish typing</div>
  </div>
  <div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<mat-card-content>

    <div id="button-switch-box">
        <div class="button-container left" [ngClass]="{'selected': isSelected('summary')}"
            (click)="selectMenuItem('summary')">
            <div style="margin-top: 9px;">
                <span class="main-box-title-14">Summary</span>
            </div>
        </div>
        <div class="separator"></div>
        <div class="button-container right" [ngClass]="{'selected': isSelected('charts')}"
            (click)="selectMenuItem('charts')">
            <div style="margin-top: 8px;">
                <img class="chart-icon"
                    src="./assets/images/extra_tab_icons/charts-icon.svg">
                <span class="main-box-title-14 padding-chart">Charts</span>
            </div>
        </div>
    </div>
    <!--------------------------------------------->
    <!--------------------------------------------->
    <!------------------SUMMARY-------------------->
    <!--------------------------------------------->
    <!--------------------------------------------->
    <ng-container *ngIf="selectedMenuItem === 'summary'">

        <span class="main-box-title-14">This tool analyses your text according to Metadiscourse markers first listed by Hyland (e.g. 2004), then modified by Bax, Waller and Nakatsuhara (2014). Click <a href="https://textinspector.com/help/metadiscourse/" class="hiperlinks" target="_blank" rel="noopener noreferrer">here</a> for an explanation. If you want to correct any analysis, go to Input below, change the tag, then click Update.</span>

        <div id="buttons-box">
            <div style="width: 70px;">

            </div>
            <span style="padding-left: 15px;">
                <button [matMenuTriggerFor]="fileMenu" class="icon-button" (click)="toggleIcon()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">

                    <span class="button-export">
                        <div><img src="../assets/images/export-con.svg" class="export-con"></div>
                        <span>Metadiscourse
                            Export</span>
                    </span>
                    <div>
                        <mat-icon class="right-icon" [ngClass]="{'rotated-icon': isIconRotated, 'normal-icon': !isIconRotated}">expand_more</mat-icon>
                    </div>
                </button>
                <mat-menu #fileMenu="matMenu" (closed)="resetIcon()" xPosition="before">
                    <button mat-menu-item (click)="export_detallado()">Export Statistics And Details</button>
                    <button mat-menu-item (click)="export_tagger()">Export Tagged Data</button>
                </mat-menu>
            </span>

        </div>
        <div class="content-show-all">
            <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
              {{ showAll ? 'Expand all' : 'Contract all' }}
            </button>
          </div>
        <div id="div_scroll">
            <div id="metadiscourse-box">
                <div style="display: flex;">
                    <div style="width: 70px;">
                        <button class="button-seeAll" *ngIf="!hideEyeIconsForSafari1561" (click)="toggleSeeAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
                            <img class="see-all-icon eye-icon" style="padding-left: 12px;" [src]="seeAllIconSrc">
                            <span class="main-box-title-12">See All</span>
                          </button>
                          
                    </div>
                    <div class="main-box-title-14"
                        style="align-items: flex-end; display: flex; height: 30px; width: 80px;padding-top: 4px;">
                        Word</div>
                </div>
                <div style="display: flex;">
                    <div class="main-box-title-14"
                        style="align-items: flex-end; display: flex; height: 30px; width: 80px; margin-right: 10px;">
                        Types</div>

                    <div class="main-box-title-14"
                        style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">
                        Tokens</div>
                    <div style="width: 60px;"></div>
                </div>

            </div>

            <ng-container *ngFor="let data of getObjectKeys(encabezados)">
                <div class="vertical-box">
                    <div *ngIf="selectedWord[data]" id="div-category">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div style="display: flex;">
                                <button class="reset-button" (click)="resetCategoryView(data)">
                                <img src="./assets/images/black_icons/back-Icon.svg">
                                </button>
                                <div class="main-box-title-16" style="padding-top: 1px;">Change Tag</div>
                        </div>
                        <button class="main-box-title-14 update-button" (click)="updateCategory(data)">Update</button>
                        </div>
                        <ng-container *ngFor="let index of [].constructor(encontrarCantidad(selectedWord[data],data )); index as i">
                            <div style="margin-bottom: 25px; margin-top: 10px;">
                                <div class="horizontal-box" style="border: none; margin-bottom: 0px;">
                                    <div class="main-box-title-12"><img *ngIf="!hideEyeIconsForSafari1561" class="eye-icon"
                                        [src]="palabraSeleccionada[data + '-' + selectedWord[data] + '-' + i] 
                                            ? './assets/images/yellow_icons/eye-on-icon.svg' 
                                            : './assets/images/eye-icon.svg'"
                                        (click)="verPalabra(selectedWord[data], data, i,true)"><strong>Word:</strong> {{selectedWord[data]}}</div>
                                    <div class="main-box-title-12"><strong>Part of speech:</strong> {{ data.toUpperCase() }}</div>
                                    <!-- <div class="main-box-title-12"><strong>Encontradas:</strong> {{data_pof[data.toUpperCase()][selectedWord[data]]}}</div> -->
                                    </div>
                    
                                    <div *ngIf="respuestaWords" class="main-box-title-12" style="display: grid;grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));gap: 10px; margin-left: 10px; margin-top: 10px;">
                                    <div *ngFor="let item of respuestaWords" style="display: flex; align-items: flex-start;">
                                        <input type="radio" 
                                            name="palabra-{{i}}" 
                                            [value]="item.value" 
                                            [checked]="isWordSelected(item.value, data, item)"
                                            (change)="onSelectionRadioChange(selectedWord[data], i, data, item.value, item.descripcion); verPalabra(selectedWord[data], data, i,false)" 
                                            />
                                            <!-- [checked]="isWordSelected(data, i, item)" -->
                                        <td class="custom-cell description-cell" style="text-align: left;">{{item.descripcion}}</td>
                                    </div>
                                </div>
                            </div>
                          </ng-container>
                        <!-- <div class="horizontal-box" style="border: none; margin-bottom: 0px;">
                          <div class="main-box-title-12"><strong>Palabra:</strong> {{selectedWord[data]}}</div>
                          <div class="main-box-title-12"><strong>Categoría:</strong> {{ data.toUpperCase() }}</div>
                          <div class="main-box-title-12"><strong>Encontradas:</strong> {{data_pof[data.toUpperCase()][selectedWord[data]]}}</div>
                        </div> -->

            
                      </div>
                      <div *ngIf="!selectedWord[data]">
                    <div class="horizontal-box" style="border: none; margin-bottom: 0px; cursor: pointer;"
                        [ngClass]="{'expanded': isExpanded[encabezados[data].Name]}" (click)="data !== 'total' && toggleExpand(encabezados[data].Name)">
                        <div style="display: flex;">
                            <div>
                                <img *ngIf="!hideEyeIconsForSafari1561" class="eye_icon" [src]="isEyeOn[data] ? './assets/images/yellow_icons/eye-on-icon.svg' : './assets/images/eye-icon.svg'"
                                    (click)="toggleEyeIcon(data); $event.stopPropagation()"
                                    [ngStyle]="data == 'total' ? {'visibility': 'hidden', 'display': 'inline-block'} : {}">
                            </div>
                            <span id="box-score" *ngIf="data == 'unlisted' || data == 'total'"
                                [ngStyle]="{'background-color': colores_dinamicos[data], 'color':'#2A3654'}">{{encabezados[data].Name}}</span>
                            <span id="box-score" *ngIf="data != 'unlisted' && data != 'total'"
                                [ngStyle]="{'background-color': colores_dinamicos[data] || 'transparent'}">{{encabezados[data].Name}}</span>
                            <div class="tooltip-container" *ngIf="data != 'total' && data != 'unlisted'" (click)="$event.stopPropagation()">
                                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                                <span class="tooltip-text">
                                {{ getCategoryDescription(encabezados[data]?.Name || '') }}
                                </span>

                            </div>
                        </div>
                        <div style="display: flex;">
                            <div class="main-box-title-14" id="div_size">{{encabezados[data].types ?
                                encabezados[data].types
                                : "--"}} ({{encabezados[data].typesPercent}})</div>

                            <div class="main-box-title-14" id="div_size">{{encabezados[data].tokens ?
                                encabezados[data].tokens : "--"}} ({{encabezados[data].tokensPercent}})</div>
                            <mat-icon class="expand-icon" 
                                [ngStyle]="data == 'total' ? {'visibility': 'hidden', 'display': 'inline-block'} : {}">
                                expand_more
                            </mat-icon>
                        </div>
                    </div>

                    <div class="words-content" *ngIf="isExpanded[encabezados[data].Name]">
                        <ng-container *ngFor="let item of getObjectKeys(data_pof[data])">
                            <div class="item-listado-errores">
                                <span (mouseenter)="ponerOjo($event, data, item)"
                                    (mouseleave)="quitarOjo($event, data, item)" style="display:flex; padding: 4px;">
                                    <ng-container *ngIf="isScreenLarge; else mobileLayout">
                                        <img src="./assets/images/eye-icon.svg" *ngIf="!palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                                            (click)="toggleEyeIconPalabra(data, item)" class="icon-eye">
                                        <img src="./assets/images/yellow_icons/eye-on-icon.svg"
                                            *ngIf="palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                                            (click)="toggleEyeIconPalabra(data, item)" class="icon-eye">
                                        <img src="./assets/images/project-icon.svg" style="margin-right: 5px;" (click)="selectWord(data, item)" class="icon-project">
                                        <div>
                                            {{item}} / {{data_pof[data][item]}}
                                        </div>
                                    </ng-container>

                                    <ng-template #mobileLayout>
                                        <img src="./assets/images/eye-icon.svg" *ngIf="!palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                                            (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye">
                                        <img src="./assets/images/yellow_icons/eye-on-icon.svg"
                                            *ngIf="palabraresaltada[data][item] && !hideEyeIconsForSafari1561"
                                            (touchstart)="toggleEyeIconPalabra(data, item)" class="icon-eye">
                                        <img src="./assets/images/project-icon.svg" style="margin-right: 5px;" (click)="selectWord(data, item)" class="icon-project">
                                        <div>
                                            {{item}} / {{data_pof[data][item]}}
                                        </div>
                                    </ng-template>
                                </span>
                            </div>
                        </ng-container>
                    </div>
                    </div>
                </div>
            </ng-container>

        </div>

    </ng-container>
    <!--------------------------------------------->
    <!--------------------------------------------->
    <!-------------------CHARTS-------------------->
    <!--------------------------------------------->
    <!--------------------------------------------->

    <ng-container *ngIf="selectedMenuItem === 'charts'">
        <div class="chart-container">
            <div id="title-chart">Types %</div>
            <div class="scroll_chart">
                <div class="size_chart">
                    <canvas id="chart" baseChart
                        [data]="barChartData" [options]="barChartOptions" [type]="barChartType">
                    </canvas>
                </div>
            </div>  
        </div>
    </ng-container>

</mat-card-content>
